// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"84c2e60d","804":"b0c5d871"}[chunkId] + ".chunk.js";
};